import React, {Component} from 'react';
import geoUtils from '../../utils/geoUtils';
import urlHandler from '../../utils/urlHandler';
import { MapContainer, WMSTileLayer, Marker, AttributionControl, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

/**
 * Thin wrapper over a MetaCarta map server (WMS tile server).
 */

class MetaCartaMap extends Component{
	constructor(props) {
        super(props);

        this.mapDisable = window._mapDisable;
        this.mapUrl = window._mapMetaCartaUrl;
        this.mapFile = window._mapMetaCartaMapFile;
        this.externalUrlsDisable = window._externalUrlsDisable;

        this.state = {
            zoom: 9,
            bounds: null,
            center: null,
            markers: []
        }

        this.mc_geo_marker = new L.Icon({
            iconUrl: require('../../styles/images/marker-places.png'),
            iconRetinaUrl: require('../../styles/images/marker-places.png'),
            iconAnchor: [17, 44],
            tooltipAnchor: [19, -27],
            iconSize: [33, 44]
        })

        this.mc_ip_marker = new L.Icon({
            iconUrl: require('../../styles/images/marker-computers.png'),
            iconRetinaUrl: require('../../styles/images/marker-computers.png'),
            iconAnchor: [17, 44],
            tooltipAnchor: [19, -27],
            iconSize: [33, 44] 
        })

        this.mc_org_marker = new L.Icon({
            iconUrl: require('../../styles/images/marker-org.png'),
            iconRetinaUrl: require('../../styles/images/marker-org.png'),
            iconAnchor: [17, 44],
            tooltipAnchor: [19, -27],
            iconSize: [33, 44]
        })
	}

    componentWillReceiveProps(nextProps) {
        if (nextProps.boundingBox && (nextProps.boundingBox != this.props.boundingBox)) {
            if (geoUtils.isPointInBoundingBox(this.props.lat, this.props.lng, nextProps.boundingBox)) {
                this.setState({
                    bounds: [
                        [nextProps.boundingBox.minLatitude, nextProps.boundingBox.minLongitude], 
                        [nextProps.boundingBox.maxLatitude, nextProps.boundingBox.maxLongitude]
                    ],
                    center: null
                });
            } else {
                this.setState({
                    bounds: null,
                    center: [this.props.lat, this.props.lng]
                });                
            }
        }
    }

    componentDidMount() {

        if (this.mapDisable) return;
        if (this.props.results) {

            var locations = this.props.results;
            var points2 = []; 				
            for( var i = 0; i<locations.length; i++){
                
                if(locations[i].entities[0].disambiguationResults !== undefined && 
                    locations[i].entities[0].disambiguationResults[0] !== undefined && 
                    locations[i].entities[0].disambiguationResults[0].attributes !== undefined && 
                    locations[i].entities[0].disambiguationResults[0].attributes.location !== undefined && 
                    locations[i].entities[0].disambiguationResults[0].attributes.location.longitude !== undefined && 
                    locations[i].entities[0].disambiguationResults[0].attributes.location.latitude !== undefined ) {
                    
                    points2.push({
                            lat: locations[i].entities[0].disambiguationResults[0].attributes.location.latitude,
                            lon: locations[i].entities[0].disambiguationResults[0].attributes.location.longitude,
                            title: locations[i].entities[0].normalizedText,
                            icon: this.mc_geo_marker
                    });
                } else if (locations[i].entities[0].attributes !== undefined &&
                    locations[i].entities[0].attributes.latitude !== undefined &&
                    locations[i].entities[0].attributes.longitude !== undefined && 
                    locations[i].entities[0].type === 'IPV4') {

                    points2.push({
                        lat: locations[i].entities[0].attributes.latitude,
                        lon: locations[i].entities[0].attributes.longitude,
                        title: locations[i].entities[0].normalizedText,
                        icon: this.mc_ip_marker
                    });
                } else if (locations[i].entities[0].attributes !== undefined &&
                    locations[i].entities[0].attributes.ipAddress !== undefined &&
                    locations[i].entities[0].attributes.ipAddress.latitude !== undefined &&
                    locations[i].entities[0].attributes.ipAddress.longitude !== undefined && 
                    locations[i].entities[0].type === 'URI') {

                    points2.push({
                        lat: locations[i].entities[0].attributes.ipAddress.latitude,
                        lon: locations[i].entities[0].attributes.ipAddress.longitude,
                        title: locations[i].entities[0].normalizedText,
                        icon: this.mc_ip_marker
                    });
                } else if (locations[i].entities[0].type.startsWith('ORGANIZATION') &&
                    locations[i].entities[0].disambiguationResults !== undefined &&
                    locations[i].entities[0].disambiguationResults[0] !== undefined) 
                {
                    //If we run across an ORG, we need to make an /entities request on the associated id as 
                    //the location information for ORGs is not available from the /enrich response.
                    //
                    if (locations[i].entities[0].disambiguationResults[0].id) {
                        urlHandler.sendRequest('entities2', null, locations[i].entities[0].disambiguationResults[0].id, null, null, (response,txt,status) => {
                            if (status == 200) {
                                if (response.location !== undefined) {
                                    if (response.location.latitude !== undefined && response.location.longitude !== undefined) {
        
                                        points2.push({
                                            lat: response.location.latitude,
                                            lon: response.location.longitude,
                                            title: response.label,
                                            icon: this.mc_org_marker
                                        });
                                    }
                                }
                            }
                        });
                    }
                }
            }

            // Determine the bounds
            var left = 180, right = -180, top = -90, bottom = 90;

            points2.map((point, index) => {
                if (point.lat < left) { left = point.lat; }
                if (point.lat > right) { right = point.lat; }
                if (point.lon < bottom) { bottom = point.lon; }
                if (point.lon > top) { top = point.lon; }
            });

            this.setState({
                markers: points2,
                bounds: [[left, bottom], [right, top]],
                center: null
            })

        } 
        
        else if (this.props.lng && this.props.lat) {

			var icon = this.mc_geo_marker;
			if (this.props.type && (this.props.type == 'IPV4' || this.props.type == 'URI')) {
				icon = this.mc_ip_marker;
			}
			else if (this.props.type && this.props.type.startsWith('ORGANIZATION')) {
				icon = this.mc_org_marker;
			} 

            var points2 = [];
            points2.push({
                lat: this.props.lat,
                lon: this.props.lng,
                title: this.props.label,
                icon
            })

            var bounds = null;
            var center = null;

            if (this.props.boundingBox) {
                if (geoUtils.isPointInBoundingBox(this.props.lat, this.props.lng, this.props.boundingBox)) {
                    bounds = [
                        [this.props.boundingBox.minLatitude, this.props.boundingBox.minLongitude], 
                        [this.props.boundingBox.maxLatitude, this.props.boundingBox.maxLongitude]
                    ];
                } else {
                    center = [this.props.lat, this.props.lng];
                }
            } else {
                center = [this.props.lat, this.props.lng];
            }

            this.setState({
                markers: points2,
                center,
                bounds
            });
        }  
    }

    //componentWillUpdate() is depcrecated - commented out during upgrade to react17
    //TODO: remove componentWillUpdate if everything works. React18 requires the depcreation fix.
	// componentWillUpdate() {

    //     if (this.refs.mapRef) {

    //         // Maps rendered under the data tab don't get rendered/updated properly without this piece .. ??
    //         var map = this.refs.mapRef.leafletElement;

    //         map.invalidateSize();

    //         if (this.state.bounds) {
    //             map.fitBounds(this.state.bounds);
    //         }
    //     }
	// }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.boundingBox !== prevProps.boundingBox) {
            if (this.props.boundingBox && geoUtils.isPointInBoundingBox(this.props.lat, this.props.lng, this.props.boundingBox)) {
                this.setState({
                    bounds: [
                    [this.props.boundingBox.minLatitude, this.props.boundingBox.minLongitude],
                    [this.props.boundingBox.maxLatitude, this.props.boundingBox.maxLongitude]
                    ],
                    center: null
                });
            } else {
                this.setState({
                    bounds: null,
                    center: [this.props.lat, this.props.lng]
                });
            }
        }

        // **handle map resizing & fitBounds**
        if (this.map) {
            this.map.invalidateSize();
            if (this.state.bounds && this.state.bounds !== prevState.bounds) {
                this.map.fitBounds(this.state.bounds);
            }
        }
    }

	render() {

        const map = this.mapUrl + '?' + 
                    'map=' + this.mapFile +  
                    '&LAYERS=Borders%2CLand%2CCities%2CLabels%2CTransportation%2CWater' + 
                    '&SERVICE=WMS' + 
                    '&VERSION=1.1.1' + 
                    '&REQUEST=GetMap' + 
                    '&STYLES=' + 
                    '&EXCEPTIONS=application%2Fvnd.ogc.se_inimage' + 
                    '&FORMAT=image%2Fjpeg' + 
                    '&SRS=EPSG%3A4326' + 
                    '&BBOX=-180,-90,180,90' + 
                    '&WIDTH=350&HEIGHT=350';

        let attribution = '&copy; <a href=&quot;https://finchcomputing.com&quot; target=&quot;__blank&quot;>Finch Computing</a>';
        if (this.externalUrlsDisable) {
            attribution = '&copy; Finch Computing'
        }

        return (
            <div className={this.props.className} style={this.props.style} hidden = {this.props.hidden || this.mapDisable} >
                <MapContainer 
                    className="metacarta-map-container map-inner-container" 
                    bounds={this.state.bounds ? this.state.bounds : undefined}
                    center={this.state.center ? this.state.center : undefined} 
                    zoom={this.state.zoom}
                    attributionControl={false}
                    whenCreated={mapInstance => { this.map = mapInstance; }}
                    style={{ height: '100%', width: '100%' }}
                >
                    <WMSTileLayer 
                        url={map}
                        prefix={false}
                        attribution
                        layers="Borders,Land,Cities,Labels,Transportation,Water"
                    />
                    <AttributionControl position="bottomright" prefix=""/>
                    {this.state.markers.map((marker, index) =>
                        <Marker key={index} position={[marker.lat, marker.lon]} icon={marker.icon}>
                            {marker.title &&
                            <Tooltip>
                                <span>{marker.title}</span>
                            </Tooltip>
                            }
                        </Marker>
                    )}
                    {/* this.state.bounds &&
                        <Rectangle bounds={this.state.bounds} color="indianred"></Rectangle>
                    */}
                </MapContainer>
            </div>
		);
	}
};

export default MetaCartaMap;